import type { AgentNode } from '@saaga/shared/interfaces/agency-node.interface'
import {
  DEFAULT_AGENT_NODE_DATA,
  ENTRY_POINT_NODE_DATA,
} from '@saaga/shared/interfaces/agency-node.interface'

import { generateNodeId } from './agency-flow-layout.util'

export const createEntryNode = (): AgentNode => ({
  id: generateNodeId(),
  type: 'agent',
  position: { x: 0, y: 0 },
  data: { ...ENTRY_POINT_NODE_DATA },
})

export const createDefaultNode = (
  position: { x: number; y: number } = { x: 0, y: 0 }
): AgentNode => ({
  id: generateNodeId(),
  type: 'agent',
  position,
  data: { ...DEFAULT_AGENT_NODE_DATA },
})

export const createNodeWithId = (
  nodeId: string,
  position: { x: number; y: number }
): AgentNode => ({
  id: nodeId,
  type: 'agent',
  position,
  data: { ...DEFAULT_AGENT_NODE_DATA },
})
